import { Component } from 'solid-js';
import { ModusWcSwitchCustomEvent } from '@trimble-oss/moduswebcomponents';
import { t } from '@trimble/i18n';

export interface BooleanRowProps {
  readonly id: string;
  readonly labelKey: string;
  readonly value: boolean;
  readonly isDisabled?: boolean;
  readonly disabledTooltipKey?: string;
  readonly switchTestId?: string;
  onChange(value: boolean): void;
}

/**
 * One labelled on/off row in a visibility menu. Layout only — toggle
 * state and side-effects are owned by the parent. Mirrors the
 * label-left / control-right layout of {@link TransparencyRow} so a
 * dropdown can mix slider rows and toggle rows without visual jitter.
 */
export const BooleanRow: Component<BooleanRowProps> = (props) => {
  const labelId = (): string => `boolean-row-${props.id}-label`;

  const handleChange = (ev: ModusWcSwitchCustomEvent<InputEvent>): void => {
    if (props.isDisabled) return;
    const checked = (ev.detail.target as HTMLInputElement).checked;
    props.onChange(checked);
  };

  return (
    <div
      class={`flex items-center justify-between gap-2 ${props.isDisabled ? 'opacity-50' : ''}`}
      data-testid={`visibility-menu-row-${props.id}`}
      title={
        props.isDisabled && props.disabledTooltipKey
          ? t(props.disabledTooltipKey)
          : undefined
      }
    >
      <span id={labelId()} class="text-sm text-base-content">
        {t(props.labelKey)}
      </span>
      <modus-wc-switch
        attr:data-testid={props.switchTestId ?? `visibility-switch-${props.id}`}
        aria-labelledby={labelId()}
        size="sm"
        value={props.value}
        disabled={props.isDisabled}
        on:inputChange={handleChange}
      />
    </div>
  );
};
